import { render } from "./CookieConsent.vue?vue&type=template&id=503a27a7&scoped=true&ts=true"
import script from "./CookieConsent.vue?vue&type=script&lang=ts"
export * from "./CookieConsent.vue?vue&type=script&lang=ts"

import "./CookieConsent.vue?vue&type=style&index=0&id=503a27a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503a27a7"]])

export default __exports__